import React, { useCallback, useState } from 'react';
import ReceiptCard from './ReceiptCard';
import DeepLinkCopiedModal from './DeepLinkCopiedModal';
import { usePushEvents } from '../../../../../hooks/PushEvents';
import {
    appDownloadEvent,
    clickEvent,
    successEvent,
    viewEvent,
} from '../../../../../hooks/PushEvents/clevertapEvents';
import { useDeepLink } from '../../../../../hooks/useDeepLink';
import { Donee, useDonorProfile } from '../../../../../api';
import { isAppleDevice } from '../../common/utils';
import { isMobile } from '../../../../GetAppModal';
import { ReceiptResponseData } from '../../../../../api';
import { Button } from '../../../../ui';

const appStoreLink =
    'https://apps.apple.com/app/apple-store/id725815127?pt=8388804&ct=oga_appdownload_receiptthankyou&mt=8';
const playStoreLink =
    'https://play.google.com/store/apps/details?id=com.pushcontrolz.givelify&referrer=utm_source%3Doga%26utm_medium%3Dweb%26utm_campaign%3Doga_appdownload_receiptthankyou';

const handleDownloadButton = () => {
    // copyDoneeIdToClipboard();
    window.location.href = isAppleDevice() ? appStoreLink : playStoreLink;
};

const locationName = 'receiptthankyou';
const postEventPayload = {
    name: 'Thank you screen',
    location: locationName,
    action: 'completed',
    voucher: 'DDL voucher',
};

const eventPayload = {
    location: locationName,
    action: 'clicked',
    name: 'thank screen bottom sheet only shown on mobile',
};

const deepLinkTitle = (
    <>
        We’ve <span className="deep-link-copied-text">copied</span> a link
        <br />
        to your full receipt
    </>
);

interface ShowReceiptProps {
    receiptData: ReceiptResponseData | undefined;
    isReceiptLoading: boolean;
    donee: Donee;
    isReceiptBlur: boolean;
}

const ShowReceipt: React.FC<ShowReceiptProps> = ({
    receiptData,
    isReceiptLoading,
    donee,
    isReceiptBlur,
}) => {
    const { pushEvent } = usePushEvents();
    const { donorProfile } = useDonorProfile();
    const [url, setUrl] = useState<string | undefined>(undefined);
    const { deepLinkState, getDeepLink, showCopiedModal, setShowCopiedModal } =
        useDeepLink(undefined, eventPayload, handleDownloadButton);

    const handleDownload = useCallback(() => {
        pushEvent(appDownloadEvent, eventPayload);
        if (receiptData?.gift) {
            getDeepLink(donee, donorProfile, '/dl/receipt', {
                key: 'receipt',
                data: receiptData.gift,
            }).then((s) => {
                s && setUrl(s);
            });
        } else {
            handleDownloadButton();
        }
    }, [pushEvent, receiptData, getDeepLink, donee, donorProfile]);

    return (
        <>
            <ReceiptCard
                organizationName={donee.organization.name}
                isReceiptBlur={isReceiptBlur}
                gift={receiptData?.gift}
                envelopes={receiptData?.envelopes}
                isLoading={isReceiptLoading}
                className={'donee-and-receipt'}
            />
            {isMobile && (
                <Button
                    color="primary"
                    loading={isReceiptLoading || deepLinkState.loading}
                    onClick={handleDownload}
                    className="w-full mt-10"
                >
                    Get the Givelify App
                </Button>
            )}
            <DeepLinkCopiedModal
                url={url}
                open={showCopiedModal}
                title={deepLinkTitle}
                viewEvent={viewEvent}
                clickEvent={clickEvent}
                successEvent={successEvent}
                clickEventPayload={postEventPayload}
                onClick={handleDownloadButton}
                onClose={() => setShowCopiedModal(false)}
            />
        </>
    );
};

export default ShowReceipt;
